import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { AnaGenerale } from '../_models/ana-generale';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';

@Injectable({
	providedIn: 'root'
})
export class CustomerService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }


	datatable(f: any) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/customers/dt`, f);
	}

	getAll() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/customers`);
	}

	get(id: number) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/customers/` + id);
	}

	update(ana: AnaGenerale) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/customers`, ana);
	}

	insert(ana: AnaGenerale) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/customers`, ana);
	}

	delete(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/customers/` + id);
	}
}
